import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "top-view" }
const _hoisted_2 = { id: "navbar" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "navbar-content" }
const _hoisted_5 = {
  id: "primary-nav",
  class: "nav"
}
const _hoisted_6 = { class: "dropdown" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "exam-selection-section" }
const _hoisted_9 = { class: "exam-list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "exam-item-content" }
const _hoisted_12 = { class: "exam-name" }
const _hoisted_13 = {
  key: 0,
  class: "fa fa-check-circle check-icon"
}
const _hoisted_14 = {
  method: "post",
  action: "#",
  name: "form"
}
const _hoisted_15 = {
  class: "table table-bordered",
  style: {"margin-top":"15px"}
}
const _hoisted_16 = {
  class: "info-field",
  style: {"text-align":"center","margin-top":"20px"}
}
const _hoisted_17 = { style: {"margin-top":"15px","margin-bottom":"15px"} }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { style: {"margin-top":"15px","margin-bottom":"15px"} }
const _hoisted_20 = {
  key: 1,
  class: "modal",
  tabindex: "-1",
  role: "dialog"
}
const _hoisted_21 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[21] || (_cache[21] = _createElementVNode("div", { id: "header" }, [
      _createElementVNode("div", { class: "container" }, [
        _createElementVNode("a", {
          class: "brand",
          href: "/"
        }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: ""
          })
        ])
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)), ["prevent"])),
                onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideDropdown && _ctx.hideDropdown(...args)))
              }, _cache[8] || (_cache[8] = [
                _createElementVNode("i", { class: "icons-white-large nav-icon-subject" }, null, -1),
                _createElementVNode("span", {
                  class: "menu-name",
                  style: {"font-size":"15px"}
                }, "MENU", -1)
              ]), 32),
              _createElementVNode("ul", {
                class: "dropdown-menu",
                style: _normalizeStyle([{"min-width":"150px"}, { display: _ctx.showDropdown ? 'block' : 'none' }])
              }, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/terms",
                    onClick: _ctx.hideDropdown
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("    利用規約")
                    ])),
                    _: 1,
                    __: [9]
                  }, 8, ["onClick"])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: "#",
                    id: "trial_request_logout",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)), ["prevent"]))
                  }, "    ログアウト")
                ])
              ], 4)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "section-title" }, "試験を選択してください", -1)),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleExamList, (exam) => {
            return (_openBlock(), _createElementBlock("div", {
              key: exam.examId,
              class: _normalizeClass(["exam-item", { 'exam-item-active': _ctx.selectedExamId === exam.examId }]),
              onClick: ($event: any) => (_ctx.selectExam(exam.examId))
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(exam.name), 1),
                (_ctx.selectedExamId === exam.examId)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_10))
          }), 128))
        ])
      ]),
      _createElementVNode("form", _hoisted_14, [
        _createElementVNode("table", _hoisted_15, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _cache[11] || (_cache[11] = _createElementVNode("td", { class: "contents-info-tbl-colhead" }, [
                _createElementVNode("strong", null, "コンテンツ名")
              ], -1)),
              _createElementVNode("td", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.selectedExam ? _ctx.selectedExam.name : ''), 1)
              ])
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("tr", null, [
              _createElementVNode("td", { class: "contents-info-tbl-colhead" }, [
                _createElementVNode("strong", null, "コンテンツ種別")
              ]),
              _createElementVNode("td", null, "テスト")
            ], -1)),
            _createElementVNode("tr", null, [
              _cache[12] || (_cache[12] = _createElementVNode("td", { class: "contents-info-tbl-colhead" }, [
                _createElementVNode("strong", null, "実施状況")
              ], -1)),
              _createElementVNode("td", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(["text-label", _ctx.isSelectedExamTaken ? 'label-success' : 'label-danger'])
                }, _toDisplayString(_ctx.isSelectedExamTaken ? '実施済' : '未実施'), 3)
              ])
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("tr", null, [
              _createElementVNode("td", { class: "contents-info-tbl-colhead" }, [
                _createElementVNode("strong", null, "実施可能回数")
              ]),
              _createElementVNode("td", null, "回数制限無し  ")
            ], -1)),
            _cache[15] || (_cache[15] = _createElementVNode("tr", null, [
              _createElementVNode("td", { class: "contents-info-tbl-colhead" }, [
                _createElementVNode("strong", null, "制限時間")
              ]),
              _createElementVNode("td", null, "50 分")
            ], -1)),
            _cache[16] || (_cache[16] = _createElementVNode("tr", null, [
              _createElementVNode("td", { class: "contents-info-tbl-colhead" }, [
                _createElementVNode("strong", null, "中断")
              ]),
              _createElementVNode("td", null, "不可")
            ], -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("a", {
              href: "#",
              id: "trial_exam_attention",
              style: {"color":"#b94a48","text-decoration":"underline"},
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showAttentionModal && _ctx.showAttentionModal(...args)), ["prevent"]))
            }, _cache[17] || (_cache[17] = [
              _createElementVNode("b", null, "注意事項 ( 必ずお読みください )", -1)
            ]))
          ]),
          _createElementVNode("input", {
            type: "button",
            class: _normalizeClass(["btn btn-primary", { 'btn-disabled': !_ctx.selectedExamId }]),
            id: "exam_execute",
            value: "実施する",
            style: {"width":"100px"},
            disabled: !_ctx.selectedExamId,
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.startExam && _ctx.startExam(...args)))
          }, null, 10, _hoisted_18),
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              value: "",
              id: "tutorial",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showTutorial) = $event)),
              style: {"margin-right":"10px"}
            }, null, 512), [
              [_vModelCheckbox, _ctx.showTutorial]
            ]),
            _cache[18] || (_cache[18] = _createTextVNode("開始前に操作説明を表示する "))
          ])
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("div", { style: {"text-align":"right"} }, null, -1))
      ])
    ]),
    (_ctx.showAttentionModalFlag)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-backdrop",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeAttentionModal && _ctx.closeAttentionModal(...args)))
        }))
      : _createCommentVNode("", true),
    (_ctx.showAttentionModalFlag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"modal-header\" data-v-458f5de7><h3 data-v-458f5de7>注意事項</h3></div><div class=\"modal-body\" data-v-458f5de7><p data-v-458f5de7><b data-v-458f5de7>■操作上の注意</b></p><p data-v-458f5de7>・ブラウザの「戻る」「進む」ボタンは使用しないでください</p><p data-v-458f5de7>・途中で中断・再開することはできません</p><p data-v-458f5de7>・入力された解答内容は自動保存されません</p><br data-v-458f5de7><p data-v-458f5de7><b data-v-458f5de7>■その他</b></p><p data-v-458f5de7>・実際の検定試験の合否を保証するものではありません</p><p data-v-458f5de7>・模擬試験プログラムで使用されるデータは、一定期間後に削除される場合があります</p></div>", 2)),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              type: "button",
              class: "btn",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeAttentionModal && _ctx.closeAttentionModal(...args)))
            }, "閉じる")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}